var cov_pog01ug7r = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Grid/utils.ts",
      hash = "779b1c558365ce742867919e47f9455ede92d05f",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Grid/utils.ts",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 4
        },
        end: {
          line: 5,
          column: 6
        }
      },
      "1": {
        start: {
          line: 6,
          column: 19
        },
        end: {
          line: 11,
          column: 1
        }
      },
      "2": {
        start: {
          line: 14,
          column: 22
        },
        end: {
          line: 14,
          column: 45
        }
      },
      "3": {
        start: {
          line: 15,
          column: 26
        },
        end: {
          line: 15,
          column: 54
        }
      },
      "4": {
        start: {
          line: 16,
          column: 26
        },
        end: {
          line: 16,
          column: 30
        }
      },
      "5": {
        start: {
          line: 19,
          column: 14
        },
        end: {
          line: 19,
          column: 81
        }
      },
      "6": {
        start: {
          line: 20,
          column: 2
        },
        end: {
          line: 22,
          column: 3
        }
      },
      "7": {
        start: {
          line: 21,
          column: 4
        },
        end: {
          line: 21,
          column: 10
        }
      },
      "8": {
        start: {
          line: 24,
          column: 2
        },
        end: {
          line: 24,
          column: 41
        }
      },
      "9": {
        start: {
          line: 25,
          column: 2
        },
        end: {
          line: 25,
          column: 25
        }
      },
      "10": {
        start: {
          line: 26,
          column: 2
        },
        end: {
          line: 26,
          column: 15
        }
      },
      "11": {
        start: {
          line: 27,
          column: 2
        },
        end: {
          line: 27,
          column: 24
        }
      },
      "12": {
        start: {
          line: 28,
          column: 2
        },
        end: {
          line: 28,
          column: 34
        }
      },
      "13": {
        start: {
          line: 32,
          column: 19
        },
        end: {
          line: 32,
          column: 41
        }
      },
      "14": {
        start: {
          line: 33,
          column: 15
        },
        end: {
          line: 33,
          column: 97
        }
      },
      "15": {
        start: {
          line: 34,
          column: 2
        },
        end: {
          line: 34,
          column: 30
        }
      },
      "16": {
        start: {
          line: 38,
          column: 19
        },
        end: {
          line: 38,
          column: 41
        }
      },
      "17": {
        start: {
          line: 39,
          column: 15
        },
        end: {
          line: 39,
          column: 103
        }
      },
      "18": {
        start: {
          line: 40,
          column: 2
        },
        end: {
          line: 40,
          column: 30
        }
      },
      "19": {
        start: {
          line: 44,
          column: 14
        },
        end: {
          line: 44,
          column: 15
        }
      },
      "20": {
        start: {
          line: 45,
          column: 21
        },
        end: {
          line: 45,
          column: 45
        }
      },
      "21": {
        start: {
          line: 47,
          column: 2
        },
        end: {
          line: 49,
          column: 3
        }
      },
      "22": {
        start: {
          line: 48,
          column: 4
        },
        end: {
          line: 48,
          column: 13
        }
      },
      "23": {
        start: {
          line: 51,
          column: 2
        },
        end: {
          line: 53,
          column: 3
        }
      },
      "24": {
        start: {
          line: 52,
          column: 4
        },
        end: {
          line: 52,
          column: 13
        }
      },
      "25": {
        start: {
          line: 54,
          column: 2
        },
        end: {
          line: 54,
          column: 46
        }
      },
      "26": {
        start: {
          line: 55,
          column: 2
        },
        end: {
          line: 55,
          column: 43
        }
      },
      "27": {
        start: {
          line: 57,
          column: 20
        },
        end: {
          line: 57,
          column: 87
        }
      },
      "28": {
        start: {
          line: 58,
          column: 2
        },
        end: {
          line: 65,
          column: 3
        }
      },
      "29": {
        start: {
          line: 59,
          column: 4
        },
        end: {
          line: 63,
          column: 5
        }
      },
      "30": {
        start: {
          line: 60,
          column: 6
        },
        end: {
          line: 60,
          column: 48
        }
      },
      "31": {
        start: {
          line: 62,
          column: 6
        },
        end: {
          line: 62,
          column: 50
        }
      },
      "32": {
        start: {
          line: 64,
          column: 4
        },
        end: {
          line: 64,
          column: 28
        }
      },
      "33": {
        start: {
          line: 66,
          column: 2
        },
        end: {
          line: 66,
          column: 18
        }
      },
      "34": {
        start: {
          line: 78,
          column: 16
        },
        end: {
          line: 78,
          column: 19
        }
      },
      "35": {
        start: {
          line: 79,
          column: 2
        },
        end: {
          line: 81,
          column: 3
        }
      },
      "36": {
        start: {
          line: 80,
          column: 4
        },
        end: {
          line: 80,
          column: 13
        }
      },
      "37": {
        start: {
          line: 82,
          column: 2
        },
        end: {
          line: 84,
          column: 3
        }
      },
      "38": {
        start: {
          line: 83,
          column: 4
        },
        end: {
          line: 83,
          column: 32
        }
      },
      "39": {
        start: {
          line: 86,
          column: 40
        },
        end: {
          line: 86,
          column: 47
        }
      },
      "40": {
        start: {
          line: 87,
          column: 20
        },
        end: {
          line: 87,
          column: 57
        }
      },
      "41": {
        start: {
          line: 88,
          column: 22
        },
        end: {
          line: 88,
          column: 62
        }
      },
      "42": {
        start: {
          line: 90,
          column: 2
        },
        end: {
          line: 90,
          column: 76
        }
      },
      "43": {
        start: {
          line: 94,
          column: 15
        },
        end: {
          line: 94,
          column: 17
        }
      },
      "44": {
        start: {
          line: 96,
          column: 2
        },
        end: {
          line: 106,
          column: 3
        }
      },
      "45": {
        start: {
          line: 108,
          column: 2
        },
        end: {
          line: 108,
          column: 48
        }
      },
      "46": {
        start: {
          line: 109,
          column: 2
        },
        end: {
          line: 109,
          column: 43
        }
      },
      "47": {
        start: {
          line: 112,
          column: 0
        },
        end: {
          line: 112,
          column: 6
        }
      }
    },
    fnMap: {
      "0": {
        name: "createStyle",
        decl: {
          start: {
            line: 18,
            column: 9
          },
          end: {
            line: 18,
            column: 20
          }
        },
        loc: {
          start: {
            line: 18,
            column: 47
          },
          end: {
            line: 29,
            column: 1
          }
        },
        line: 18
      },
      "1": {
        name: "generateGrid",
        decl: {
          start: {
            line: 31,
            column: 9
          },
          end: {
            line: 31,
            column: 21
          }
        },
        loc: {
          start: {
            line: 31,
            column: 89
          },
          end: {
            line: 35,
            column: 1
          }
        },
        line: 31
      },
      "2": {
        name: "generateOffset",
        decl: {
          start: {
            line: 37,
            column: 9
          },
          end: {
            line: 37,
            column: 23
          }
        },
        loc: {
          start: {
            line: 37,
            column: 91
          },
          end: {
            line: 41,
            column: 1
          }
        },
        line: 37
      },
      "3": {
        name: "generate",
        decl: {
          start: {
            line: 43,
            column: 9
          },
          end: {
            line: 43,
            column: 17
          }
        },
        loc: {
          start: {
            line: 43,
            column: 80
          },
          end: {
            line: 67,
            column: 1
          }
        },
        line: 43
      },
      "4": {
        name: "getGrid",
        decl: {
          start: {
            line: 69,
            column: 16
          },
          end: {
            line: 69,
            column: 23
          }
        },
        loc: {
          start: {
            line: 77,
            column: 2
          },
          end: {
            line: 91,
            column: 1
          }
        },
        line: 77
      },
      "5": {
        name: "init",
        decl: {
          start: {
            line: 93,
            column: 9
          },
          end: {
            line: 93,
            column: 13
          }
        },
        loc: {
          start: {
            line: 93,
            column: 16
          },
          end: {
            line: 110,
            column: 1
          }
        },
        line: 93
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 20,
            column: 2
          },
          end: {
            line: 22,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 20,
            column: 2
          },
          end: {
            line: 22,
            column: 3
          }
        }, {
          start: {
            line: 20,
            column: 2
          },
          end: {
            line: 22,
            column: 3
          }
        }],
        line: 20
      },
      "1": {
        loc: {
          start: {
            line: 45,
            column: 21
          },
          end: {
            line: 45,
            column: 45
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 45,
            column: 21
          },
          end: {
            line: 45,
            column: 24
          }
        }, {
          start: {
            line: 45,
            column: 28
          },
          end: {
            line: 45,
            column: 45
          }
        }],
        line: 45
      },
      "2": {
        loc: {
          start: {
            line: 47,
            column: 2
          },
          end: {
            line: 49,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 47,
            column: 2
          },
          end: {
            line: 49,
            column: 3
          }
        }, {
          start: {
            line: 47,
            column: 2
          },
          end: {
            line: 49,
            column: 3
          }
        }],
        line: 47
      },
      "3": {
        loc: {
          start: {
            line: 47,
            column: 6
          },
          end: {
            line: 47,
            column: 26
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 47,
            column: 6
          },
          end: {
            line: 47,
            column: 12
          }
        }, {
          start: {
            line: 47,
            column: 16
          },
          end: {
            line: 47,
            column: 26
          }
        }],
        line: 47
      },
      "4": {
        loc: {
          start: {
            line: 51,
            column: 2
          },
          end: {
            line: 53,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 51,
            column: 2
          },
          end: {
            line: 53,
            column: 3
          }
        }, {
          start: {
            line: 51,
            column: 2
          },
          end: {
            line: 53,
            column: 3
          }
        }],
        line: 51
      },
      "5": {
        loc: {
          start: {
            line: 58,
            column: 2
          },
          end: {
            line: 65,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 58,
            column: 2
          },
          end: {
            line: 65,
            column: 3
          }
        }, {
          start: {
            line: 58,
            column: 2
          },
          end: {
            line: 65,
            column: 3
          }
        }],
        line: 58
      },
      "6": {
        loc: {
          start: {
            line: 59,
            column: 4
          },
          end: {
            line: 63,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 59,
            column: 4
          },
          end: {
            line: 63,
            column: 5
          }
        }, {
          start: {
            line: 59,
            column: 4
          },
          end: {
            line: 63,
            column: 5
          }
        }],
        line: 59
      },
      "7": {
        loc: {
          start: {
            line: 79,
            column: 2
          },
          end: {
            line: 81,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 79,
            column: 2
          },
          end: {
            line: 81,
            column: 3
          }
        }, {
          start: {
            line: 79,
            column: 2
          },
          end: {
            line: 81,
            column: 3
          }
        }],
        line: 79
      },
      "8": {
        loc: {
          start: {
            line: 82,
            column: 2
          },
          end: {
            line: 84,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 82,
            column: 2
          },
          end: {
            line: 84,
            column: 3
          }
        }, {
          start: {
            line: 82,
            column: 2
          },
          end: {
            line: 84,
            column: 3
          }
        }],
        line: 82
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import config from '../config';
var CACHES = (cov_pog01ug7r.s[0]++, {});
var RESPONSIVE = (cov_pog01ug7r.s[1]++, {
  sm: '568',
  md: '768',
  lg: '992',
  xl: '1200'
});
var GridClassName = (cov_pog01ug7r.s[2]++, "".concat(config.prefix, "-grid"));
var GridFullClassName = (cov_pog01ug7r.s[3]++, "".concat(config.prefix, "-grid-full"));
var defaultResponsive = (cov_pog01ug7r.s[4]++, 'md');

function createStyle(text, id) {
  cov_pog01ug7r.f[0]++;
  var style = (cov_pog01ug7r.s[5]++, document.head.querySelector("#".concat(id)));
  cov_pog01ug7r.s[6]++;

  if (style) {
    cov_pog01ug7r.b[0][0]++;
    cov_pog01ug7r.s[7]++;
    return;
  } else {
    cov_pog01ug7r.b[0][1]++;
  }

  cov_pog01ug7r.s[8]++;
  style = document.createElement('style');
  cov_pog01ug7r.s[9]++;
  style.type = 'text/css';
  cov_pog01ug7r.s[10]++;
  style.id = id;
  cov_pog01ug7r.s[11]++;
  style.innerHTML = text;
  cov_pog01ug7r.s[12]++;
  document.head.appendChild(style);
}

function generateGrid(width, className, responsive) {
  cov_pog01ug7r.f[1]++;
  var minWidth = (cov_pog01ug7r.s[13]++, RESPONSIVE[responsive]);
  var text = (cov_pog01ug7r.s[14]++, "@media screen and (min-width: ".concat(minWidth, "px) { .").concat(className, "{width: ").concat(width, "%} }"));
  cov_pog01ug7r.s[15]++;
  createStyle(text, className);
}

function generateOffset(width, className, responsive) {
  cov_pog01ug7r.f[2]++;
  var minWidth = (cov_pog01ug7r.s[16]++, RESPONSIVE[responsive]);
  var text = (cov_pog01ug7r.s[17]++, "@media screen and (min-width: ".concat(minWidth, "px) { .").concat(className, "{margin-left: ").concat(width, "%} }"));
  cov_pog01ug7r.s[18]++;
  createStyle(text, className);
}

function generate(w, type, res) {
  cov_pog01ug7r.f[3]++;
  var width = (cov_pog01ug7r.s[19]++, w);
  var responsive = (cov_pog01ug7r.s[20]++, (cov_pog01ug7r.b[1][0]++, res) || (cov_pog01ug7r.b[1][1]++, defaultResponsive));
  cov_pog01ug7r.s[21]++;

  if ((cov_pog01ug7r.b[3][0]++, !width) || (cov_pog01ug7r.b[3][1]++, width <= 0)) {
    cov_pog01ug7r.b[2][0]++;
    cov_pog01ug7r.s[22]++;
    return '';
  } else {
    cov_pog01ug7r.b[2][1]++;
  }

  cov_pog01ug7r.s[23]++;

  if (width > 1) {
    cov_pog01ug7r.b[4][0]++;
    cov_pog01ug7r.s[24]++;
    width = 1;
  } else {
    cov_pog01ug7r.b[4][1]++;
  }

  cov_pog01ug7r.s[25]++;
  width = (width * 100).toFixed(4);
  cov_pog01ug7r.s[26]++;
  width = width.substr(0, width.length - 1);
  var className = (cov_pog01ug7r.s[27]++, "".concat(config.prefix, "-").concat(type, "-").concat(responsive, "-").concat(width.replace('.', '-')));
  cov_pog01ug7r.s[28]++;

  if (!CACHES[className]) {
    cov_pog01ug7r.b[5][0]++;
    cov_pog01ug7r.s[29]++;

    if (type === 'grid') {
      cov_pog01ug7r.b[6][0]++;
      cov_pog01ug7r.s[30]++;
      generateGrid(width, className, responsive);
    } else {
      cov_pog01ug7r.b[6][1]++;
      cov_pog01ug7r.s[31]++;
      generateOffset(width, className, responsive);
    }

    cov_pog01ug7r.s[32]++;
    CACHES[className] = true;
  } else {
    cov_pog01ug7r.b[5][1]++;
  }

  cov_pog01ug7r.s[33]++;
  return className;
}

export function getGrid(opt) {
  cov_pog01ug7r.f[4]++;
  var options = (cov_pog01ug7r.s[34]++, opt);
  cov_pog01ug7r.s[35]++;

  if (!options) {
    cov_pog01ug7r.b[7][0]++;
    cov_pog01ug7r.s[36]++;
    return '';
  } else {
    cov_pog01ug7r.b[7][1]++;
  }

  cov_pog01ug7r.s[37]++;

  if (typeof options === 'number') {
    cov_pog01ug7r.b[8][0]++;
    cov_pog01ug7r.s[38]++;
    options = {
      width: options
    };
  } else {
    cov_pog01ug7r.b[8][1]++;
  }

  var _ref = (cov_pog01ug7r.s[39]++, options),
      width = _ref.width,
      offset = _ref.offset,
      responsive = _ref.responsive;

  var gridClass = (cov_pog01ug7r.s[40]++, generate(width, 'grid', responsive));
  var offsetClass = (cov_pog01ug7r.s[41]++, generate(offset, 'offset', responsive));
  cov_pog01ug7r.s[42]++;
  return "".concat(GridClassName, " ").concat(GridFullClassName, " ").concat(gridClass, " ").concat(offsetClass);
}

function init() {
  cov_pog01ug7r.f[5]++;
  var text = (cov_pog01ug7r.s[43]++, []);
  cov_pog01ug7r.s[44]++;
  text.push("\n.".concat(GridClassName, " {\n  position: relative;\n  display: inline-block;\n  zoom: 1;\n  letter-spacing: normal;\n  word-spacing: normal;\n  vertical-align: top;\n  text-rendering: auto;\n  box-sizing: border-box;\n}"));
  cov_pog01ug7r.s[45]++;
  text.push(".".concat(GridFullClassName, "{width:100%}"));
  cov_pog01ug7r.s[46]++;
  createStyle(text.join(''), GridClassName);
}

cov_pog01ug7r.s[47]++;
init();